(() => {
  'use strict';
  const order = ['front', 'back', 'detail', 'lifestyle'];
  const normalize = value => String(value || '').trim().toLowerCase();
  document.querySelectorAll('[data-bs-stills]').forEach(gallery => {
    if (gallery.dataset.initialized) return;
    gallery.dataset.initialized = 'true';
    const shop = gallery.closest('[data-bs-shop]');
    const viewer = shop?.querySelector('[data-bs-viewer]');
    if (!viewer) return;
    const track = gallery.querySelector('[data-bs-stills-track]');
    const thumbnails = gallery.querySelector('[data-bs-stills-thumbnails]');
    const position = gallery.querySelector('[data-bs-stills-position]');
    const mobile = matchMedia('(max-width: 949px)');
    let product, labels, mapping, key = '', selected = 0, near = false, filled = false;
    const products = new Map(), pending = new Set();
    const loadProduct = id => {
      const meta = mapping?._products?.[id];
      if (!meta || pending.has(id)) return;
      pending.add(id);
      fetch(`${shop.dataset.root || '/'}products/${encodeURIComponent(meta.handle)}.js`, {credentials: 'same-origin'})
        .then(response => { if (!response.ok) throw new Error('Missing product'); return response.json(); })
        .then(value => { if (String(value.id) !== id) throw new Error('Product mismatch'); products.set(id, value); update(); })
        .catch(() => { if (viewer.dataset.productId === id) close(); });
    };
    let shots = [], frames = [], buttons = [], frameRequest;
    const close = () => {
      gallery.hidden = true;
      track.replaceChildren();
      thumbnails.replaceChildren();
      position.textContent = '';
      key = '';
      filled = false;
      shots = []; frames = []; buttons = [];
    };
    const select = (index, scroll = true) => {
      selected = index;
      frames.forEach((frame, i) => {
        frame.dataset.active = String(i === index);
        frame.setAttribute('aria-hidden', String(!mobile.matches && i !== index));
      });
      buttons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
      position.textContent = `${labels[order[index]]} · ${index + 1} / 4`;
      if (scroll && mobile.matches) track.scrollTo({left: index * track.clientWidth, behavior: 'instant'});
    };
    const image = (shot, thumbnail = false) => {
      const img = shot.template ? shot.template.content.querySelector('img').cloneNode(true) : document.createElement('img');
      if (!shot.template) {
        const url = new URL(shot.media.url);
        if (url.protocol !== 'https:' || !['cdn.shopify.com', location.hostname].includes(url.hostname)) throw new Error('Invalid media host');
        const sized = width => { const copy = new URL(url); copy.searchParams.set('width', width); return copy.href; };
        img.src = sized(1120);
        img.srcset = [280, 560, 840, 1120].map(width => `${sized(width)} ${width}w`).join(', ');
        img.sizes = '(max-width: 949px) calc(100vw - 32px), 42vw';
        img.width = shot.media.width || 1120;
        img.height = shot.media.height || 1400;
      }
      img.alt = thumbnail ? '' : `Bón Sin ${product.title.replace(/^b[oó]n sin\s*/i, '')} — ${shot.color} — ${labels[shot.name]}`;
      img.loading = 'lazy';
      img.decoding = 'async';
      img.fetchPriority = 'low';
      if (thumbnail) img.sizes = '(max-width: 949px) 22vw, 10vw';
      const imageKey = key;
      img.addEventListener('error', () => { if (key === imageKey) close(); }, {once: true});
      return img;
    };
    const fill = () => {
      const ready = viewer.dataset.loaded === 'true' || ['poster', 'unavailable'].includes(viewer.dataset.visual);
      if (filled || !near || !ready || !key) return;
      try {
        filled = true;
        shots.forEach((shot, i) => {
          frames[i].append(image(shot));
          buttons[i].prepend(image(shot, true));
        });
      } catch { close(); }
    };
    const update = () => {
      try {
        if (!mapping) { close(); return; }
        const id = String(viewer.dataset.productId);
        if (String(product?.id) !== id) {
          close();
          if (!products.has(id)) { loadProduct(id); return; }
          product = products.get(id);
        }
        const variant = product.variants.find(item => String(item.id) === viewer.dataset.variantId);
        const colorIndex = product.options.findIndex(option => /^(color|colour)$/i.test(String(typeof option === 'string' ? option : option.name).trim()));
        const color = colorIndex < 0 ? mapping._products?.[id]?.defaultColor || '' : (variant?.options || [variant?.option1, variant?.option2, variant?.option3])[colorIndex];
        const entry = mapping[product.handle]?.[normalize(color)];
        if (!variant || !entry || order.some(name => !entry[name])) { close(); return; }
        const nextKey = `${product.id}:${normalize(color)}:${order.map(name => entry[name]).join(',')}`;
        if (nextKey === key) { fill(); return; }
        close();
        const nextShots = order.map(name => {
          const id = String(entry[name]).split('/').pop();
          if (!/^\d+$/.test(id)) throw new Error('Invalid media ID');
          const template = gallery.querySelector(`template[data-bs-still-media="${id}"]`);
          const media = mapping._media?.[id];
          if (!template?.content.querySelector('img') && !media?.url) throw new Error('Missing media');
          return {name, template, media, color};
        });
        key = nextKey;
        shots = nextShots;
        frames = shots.map(shot => {
          const frame = document.createElement('figure');
          frame.className = 'bs-stills-frame';
          frame.dataset.shot = shot.name;
          track.append(frame);
          return frame;
        });
        buttons = shots.map((shot, i) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'bs-stills-thumb';
          button.setAttribute('aria-label', labels[shot.name]);
          const label = document.createElement('span');
          label.textContent = labels[shot.name];
          button.append(label);
          button.addEventListener('click', () => select(i));
          thumbnails.append(button);
          return button;
        });
        gallery.hidden = false;
        select(0);
        fill();
      } catch { close(); }
    };
    try {
      product = JSON.parse(gallery.querySelector('[data-bs-stills-product]').textContent);
      products.set(String(product.id), product);
      labels = JSON.parse(gallery.querySelector('[data-bs-stills-labels]').textContent);
      new MutationObserver(update).observe(viewer, {attributes: true, attributeFilter: ['data-product-id', 'data-variant-id', 'data-loaded', 'data-visual']});
      new IntersectionObserver(entries => {
        near = entries.some(entry => entry.isIntersecting);
        fill();
      }, {rootMargin: '100px'}).observe(gallery);
      track.addEventListener('scroll', () => {
        if (!mobile.matches || !frames.length) return;
        cancelAnimationFrame(frameRequest);
        frameRequest = requestAnimationFrame(() => select(Math.max(0, Math.min(3, Math.round(track.scrollLeft / Math.max(1, track.clientWidth)))), false));
      }, {passive: true});
      mobile.addEventListener('change', () => { if (frames.length) select(selected); });
      fetch(gallery.dataset.mapUrl, {credentials: 'same-origin'})
        .then(response => { if (!response.ok) throw new Error('Missing mapping'); return response.json(); })
        .then(value => { mapping = value; update(); })
        .catch(close);
    } catch { close(); }
  });
})();
